<div class="filter-cards-container">
  <!-- Skeleton loaders while loading -->
  <ng-container *ngIf="loading">
    <div class="filter-card-wrapper skeleton-card" *ngFor="let i of [1, 2, 3, 4]">
      <div class="filter-card-header">
        <app-skeleton width="40px" height="40px" borderRadius="0.5rem"></app-skeleton>
      </div>
      <div class="filter-card-content">
        <app-skeleton width="100%" height="36px" borderRadius="0.5rem" *ngFor="let j of [1, 2, 3, 4, 5]"></app-skeleton>
      </div>
    </div>
  </ng-container>

  <!-- Actual filter cards -->
  <ng-container *ngIf="!loading">
    <ng-container *ngFor="let card of filterCards">
      <!-- Standard filter items card -->
      <div class="filter-card-wrapper" *ngIf="card.type === 'items'">
        <div class="filter-card-header">
          <div class="filter-card-icon">
            <i class="fas" [ngClass]="card.icon"></i>
          </div>
          <h3 class="filter-card-title">{{ card.title | transloco }}</h3>
          <button
            *ngIf="shouldShowToggle(card)"
            class="expand-toggle-btn"
            (click)="toggleShowMore(card)"
            [attr.aria-label]="(card.expanded ? 'filters.showLess' : 'filters.showMore') | transloco">
            <i class="fas" [ngClass]="card.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
        <div class="filter-card-content">
          <div
            class="filter-item"
            [class.filter-item--selected]="item.selected"
            *ngFor="let item of getVisibleItems(card)"
            (click)="toggleFilterItem(card, item)">
            <p class="filter-item__title">
              {{ item.title | transloco }}
              <span class="filter-item__count">{{ item.count }}</span>
            </p>
          </div>
        </div>
        <div class="filter-card-footer" *ngIf="shouldShowToggle(card)">
          <button class="btn btn--text" (click)="toggleShowMore(card)">
            {{ card.expanded ? ('filters.showLess' | transloco) : ('filters.showAllCount' | transloco: { count: (card.items || []).length }) }}
          </button>
        </div>
      </div>

      <!-- Salary filter card -->
      <div class="filter-card-wrapper" *ngIf="card.type === 'salary'">
        <div class="filter-card-header">
          <div class="filter-card-icon">
            <i class="fas" [ngClass]="card.icon"></i>
          </div>
          <h3 class="filter-card-title">{{ card.title | transloco }}</h3>
        </div>
        <div class="filter-card-content">
          <div class="salary-range">
            <div class="salary-inputs">
              <div class="salary-input">
                <span>{{ 'filters.from' | transloco }}</span>
                <div class="input-with-icon">
                  <input type="number" [(ngModel)]="salaryRange.min" placeholder="0" (ngModelChange)="onSalaryChange()" />
                  <span class="currency">€</span>
                </div>
              </div>
              <div class="salary-input">
                <span>{{ 'filters.to' | transloco }}</span>
                <div class="input-with-icon">
                  <input type="number" [(ngModel)]="salaryRange.max" placeholder="5000" (ngModelChange)="onSalaryChange()" />
                  <span class="currency">€</span>
                </div>
              </div>
            </div>
            <div class="salary-period">
              <label class="salary-period__label" for="salary-period-select">{{ 'filters.per' | transloco }}</label>
              <div class="salary-period__select-wrapper">
                <select
                  id="salary-period-select"
                  class="salary-period__select"
                  [ngModel]="selectedSalaryPeriodKey"
                  (ngModelChange)="setSalaryPeriod($event)">
                  <option *ngFor="let period of salaryPeriods; trackBy: trackByPeriodKey" [value]="period.periodKey">
                    {{ 'jobSalaryPeriods.' + period.periodKey | transloco }}
                  </option>
                </select>
                <i class="fas fa-chevron-down salary-period__chevron" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Checkbox filter card -->
      <div class="filter-card-wrapper" *ngIf="card.type === 'checkboxes'">
        <div class="filter-card-header">
          <div class="filter-card-icon">
            <i class="fas" [ngClass]="card.icon"></i>
          </div>
          <h3 class="filter-card-title">{{ card.title | transloco }}</h3>
          <button
            *ngIf="shouldShowToggle(card)"
            class="expand-toggle-btn"
            (click)="toggleShowMore(card)"
            [attr.aria-label]="(card.expanded ? 'filters.showLess' : 'filters.showMore') | transloco">
            <i class="fas" [ngClass]="card.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
        <div class="filter-card-content">
          <div class="filter-options">
            <label class="checkbox" *ngFor="let item of getVisibleItems(card)">
              <input type="checkbox" />
              <span class="checkbox__label">{{ item.title | transloco }} ({{ item.count }})</span>
            </label>
          </div>
        </div>
        <div class="filter-card-footer" *ngIf="shouldShowToggle(card)">
          <button class="btn btn--text" (click)="toggleShowMore(card)">
            {{ card.expanded ? ('filters.showLess' | transloco) : ('filters.showAllCount' | transloco: { count: (card.items || []).length }) }}
          </button>
        </div>
      </div>

      <!-- Companies filter card (shows max 5 items with link to companies page) -->
      <div class="filter-card-wrapper" *ngIf="card.type === 'companies'">
        <div class="filter-card-header">
          <div class="filter-card-icon">
            <i class="fas" [ngClass]="card.icon"></i>
          </div>
          <h3 class="filter-card-title">{{ card.title | transloco }}</h3>
        </div>
        <div class="filter-card-content">
          <div
            class="filter-item"
            [class.filter-item--selected]="item.selected"
            *ngFor="let item of card.items.slice(0, card.maxItems || 5)"
            (click)="toggleFilterItem(card, item)">
            <p class="filter-item__title">
              {{ item.title }}
              <span class="filter-item__count">{{ item.count }}</span>
            </p>
          </div>
        </div>
        <div class="filter-card-footer" *ngIf="card.footerLink && card.items.length > (card.maxItems || 5)">
          <a class="btn btn--text show-more-link" [routerLink]="card.footerLink">
            {{ card.footerText || 'filters.showMore' | transloco }}
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
